export type MessageHandler = (data: any) => Promise<void>;
type MessageHandlers = {
  [key: string]: MessageHandler;
};

export class MessageQueue {
  private queue: any[] = [];
  private processing = false;
  private isActive = true;
  private handlers: MessageHandlers = {};
  registerHandler(type: string, handler: MessageHandler) {
    this.handlers[type] = handler;
  }
  unregisterHandler(type: string) {
    delete this.handlers[type];
  }
  cleanup() {
    this.isActive = false;
    this.queue = [];
    this.processing = false;
    this.handlers = {};
  }
  async enqueue(message: any) {
    if (!this.isActive) return;
    this.queue.push(message);
    if (!this.processing) {
      await this.processQueue();
    }
  }
  private async processQueue() {
    if (this.queue.length === 0 || !this.isActive) {
      this.processing = false;
      return;
    }
    this.processing = true;
    const message = this.queue.shift();
    try {
      const data = typeof message === "string" ? JSON.parse(message) : message;
      const handler = this.handlers[data.type] || this.handlers[data.channelId];
      if (handler) {
        await handler(data);
      } else {
        console.warn("[WS] No handler registered for message type:", data.type);
      }
    } catch (error) {
      console.error("[WS] Message processing error:", error);
    }
    if (this.isActive) {
      await this.processQueue();
    }
  }
}
